/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { styled } from '@mui/material';
import theme from '../../../../../Shared/Themes/theme';

export const ReassignOuterDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '1.875rem',
  gap: '1rem',
  marginRight: '1.875rem',
  marginBottom: '1.875rem',
  alignContent: 'flex-start',
  [theme.breakpoints.down('laptop')]: {
    flexDirection: 'column',
  },
}));

export const VendorCard = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  boxShadow: '0rem 0.625rem 1.25rem 0.375rem rgba(121, 87, 0, 0.10)',
  padding: '0.625rem',
  borderRadius: '0.625rem',
  alignItems: 'center',
  height: '100%',

  flex: '1 1 18.75rem',
  minWidth: '17.5rem',
  maxWidth: '100%',
  '.medium-zoom &': {
    maxWidth: 'calc(25% - 1rem)',
  },
  '.zoomed-out &': {
    maxWidth: 'calc(33.333% - 1rem)',
  },

  [theme.breakpoints.down('laptop')]: {
    flex: '1 1 100%',
    maxWidth: '100%',
  },
}));

export const VendorText = styled('div')(({ theme }) => ({
  marginLeft: '1rem',
  marginRight: '1rem',
  fontFamily: theme.typography.fontFamily,
  minWidth: '2.5rem',
  fontSize: '1rem',
  fontWeight: theme.typography.fontWeightBold,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
}));

export const LogoWrapperDiv = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const RadioButtonStyles = {
  radioStyles: {
    width: '1.25rem',
    height: '1.25rem',
    color: theme.palette.common.black,
    '&.Mui-checked': {
      color: theme.palette.common.black,
      backgroundColor: theme.palette.primary.main,
      '& + span:last-child': {
        fontWeight: theme.typography.fontWeightBold,
      },
    },
  },
  formStyles: {
    marginLeft: 'auto',
    '&.MuiFormControlLabel-root': {
      '& > span:last-child': {
        display: 'none',
      },
    },
  },
};

export const PaginationDiv = styled('div')(() => ({
  justifyContent: 'space-between',
  display: 'flex',
}));
